import React from 'react';

import './ColorOverlay.module.css';

const colorMatrix = {
  'blue-overlay': [
    '0.02',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0.38',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0.78',
    '0',
    '0',
    '0',
    '0',
    '0',
    '1',
    '0'
  ],
  'gray-overlay': [
    '0.4',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0.4',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0.42',
    '0',
    '0',
    '0',
    '0',
    '0',
    '1',
    '0'
  ]
};

const ColorOverlay = ({ imageOverlay }) => {
  const color = colorMatrix[imageOverlay];

  return (
    <svg styleName="defs-only">
      <filter
        id={imageOverlay}
        color-interpolation-filters="sRGB"
        x="0"
        y="0"
        height="100%"
        width="100%"
      >
        <feColorMatrix type="matrix" values={color} />
      </filter>
    </svg>
  );
};

export default ColorOverlay;
